function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6 75.2V65.2736L53.7136 65.5552C59.8368 66.1168 65.6 61.3424 65.6 55.3056V48.8032L70.6608 45.9952C71.9424 45.2928 72.3696 43.7488 71.6576 42.4848L64 30.4C62.4336 17.3424 54.4 6.39999 36.4816 6.39999C16.544 6.39999 8 19.7392 8 34.4816C8 40.3792 11.0832 45.8544 14.216 50.3472C17.3488 54.84 19.2 60.176 19.2 65.6528V75.2",
  stroke: "black",
  strokeWidth: 3.2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6 75.2V41.6C25.6 41.6 24.3392 41.6 24 41.6C20.8 41.6 19.2 39.304 19.2 36.8C19.2 36.2528 19.2 36.3824 19.2 35.6528C18.0208 35.1376 17.6 33.8304 17.6 32.6816C17.6 31.4784 18.3152 30.5568 19.2688 29.968C18.3264 29.4848 17.6 28.1808 17.6 27.0464C17.6 25.8768 18.2768 24.8 19.2688 24.3328C19.264 24.2384 19.2688 24.2208 19.2688 24.1248C19.2688 21.3584 21.5136 19.0752 24.2768 19.1968C24.4832 19.2064 24.7584 19.1936 25.008 19.1968C25.8672 17.6752 27.1008 16.6112 28.9728 16.6112C30.4336 16.6112 31.5808 17.2864 31.9984 17.6C32.9376 16.7648 33.7728 16 35.5456 16C36.7984 16 38.9888 16.4528 40.1376 17.6C41.3904 16.8688 42.3072 16.6112 43.6848 16.6112C45.9424 16.6112 47.5568 17.8032 48.3744 19.7648C50.5872 19.7648 52.8976 21.8352 52.8976 24.0992C54.3536 24.4144 56 26.4464 56 28.8C56 31.5296 54.3408 33.5264 51.5232 33.5264C51.4448 33.5264 51.3616 33.5264 51.272 33.5264C50.7504 34.9552 49.6 36.8 47.1536 36.8C46.1088 36.8 41.6 36.8 41.6 36.8C41.6 41.6 38.048 42.944 35.376 43.9984C33.3168 44.8112 32 46.84 32 49.0544V75.2",
  stroke: "black",
  strokeWidth: 3.2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

function SvgBrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.6212476d.svg";
export { ForwardRef as ReactComponent };